import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

// We exclude these, since they are parent target audiences,
// and we only want child target audiences. This is the easiest
// way to do this for now.
const EXCLUDED_TARGET_AUDIENCE_FACET_VALUES = ['Voor professionals', 'Voor ouders'];

export const searchAttributes = [
  'target_audience',
  'theme',
  'page_title',
  'name',
  'description',
  'body',
  'body_summarized',
  'author_full_name',
  'contact_person_full_name',
  'rendered_item',
  'colleague_full_name',
];

export const resultAttributes = [
  'uuid',
  'type',
  'vid',
  'url',
  'page_title',
  'name',
  'description',
  'body',
  'body_summarized',
  'image_style_uri',
  'theme_path',
  'author_full_name',
  'author_profile_picture',
  'contact_person_full_name',
  'contact_person_profile_picture',
  'image_svg_url',
  'colleague_full_name',
  'colleague_profile_picture',
  'colleague_team_url',
  'colleague_team_title',
  'colleague_team_summary',
  'parent_uuid',
  'parent_name',
  'theme',
];

export const facetAttributes: Exclude<SearchkitWrapperProps['searchSettings']['facet_attributes'], undefined> = [
  {
    attribute: 'targetAudience',
    field: 'target_audience',
    type: 'string',
    facetQuery: (field, size) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
        exclude: EXCLUDED_TARGET_AUDIENCE_FACET_VALUES,
      },
    }),
  },
  {
    attribute: 'theme',
    field: 'theme',
    type: 'string',
    facetQuery: (field, size) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
      },
    }),
  },
];
